import React from "react";
import useQueryApplicationById from "./useQueryApplicationById.js";
import WaitForData from "../../common/data-fetching/WaitForData.js";
import WithRedirectionUserIsAuthorized from "../../authentication-ui/WithRedirectionUserIsAuthorized.js";
import ApplicationPreview from "./ApplicationPreview.js";

export default function ApplicationItem(props) {
  const { applicationId } = props;

  const {
    data: application,
    loading:applicationLoading,
    errors: applicationErrors,
  } = useQueryApplicationById(applicationId);

  return (
    <WithRedirectionUserIsAuthorized
      yes={() => (
        <WaitForData
          loading={applicationLoading}
          errors={applicationErrors}
          onLoaded={() => (
            <>
              <ApplicationPreview application={application}/>
            </>
          )}
        />
      )}
    />
  );
}
